// extracted by mini-css-extract-plugin
export default {"white":"#fff","notificationRed":"#ff4c68","primaryIcon":"#309df0","menuHeader":"#f9f9fa","PanelFooter":"bcs_a bhk_b bhk_uy bhk_rt bhk_ru bhk_vs","PanelFooter--link":"bcs_b"};